export default __webpack_public_path__ + "static/media/img_mizan1.80cdca69.png";